import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../images/Logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">

        <div className="row align-items-start justify-content-between footer-row">

          {/* Column 1 */}
          <div className="col-lg-3 col-md-6 col-12 footer-col-center">
            <img src={logo} alt="Logo" className="footer-logo" />
            <h6 className="logo-text">JAT TECHNOCRAFT</h6>
            <p className="footer-desc">
              Professionally managed air conditioner manufacturing and job work
              organization established in 2015.
            </p>
          </div>

          {/* Column 2 */}
          <div className="col-lg-3 col-md-6 col-12">
            <h6 className="footer-heading">Quick Links</h6>

            <ul className="footer-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/aboutus">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/infrastructure">Infrastructure</Link></li>
              <li><Link to="/contactus">Contact</Link></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="col-lg-3 col-md-6 col-12">
            <h6 className="footer-heading">Our Expertise</h6>
            <ul className="footer-list">
              <li>AC Assembly Job Work</li>
              <li>OEM Manufacturing</li>
              <li>Component Testing</li>
              <li>Quality Inspection</li>
              <li>Custom Solutions</li>
            </ul>
          </div>

          {/* Column 4 */}
          <div className="col-lg-3 col-md-6 col-12">
            <h6 className="footer-heading">Contact Info</h6>
            <p className="footer-contact">
              PLOT NO. H-31/1, MIDC WALUJ<br />
              CHHATRAPATI SAMBHAJINAGAR – 431133
            </p>
            <p className="footer-contact">+91-XXXXXXXXXX</p>
            <p className="footer-contact">info@jattechnocraft.com</p>
          </div>

        </div>

        <div className="footer-bottom">
          © 2026 Jat Technocraft Pvt. Ltd. Designed by |{" "}
          <a
            href="https://etzel.co.in/"
            target="_blank"
            rel="noreferrer"
          >
            Etzel IT
          </a>
        </div>

      </div>
    </footer>
  );
}